import React from 'react';

export default function Progress({ step, totalSteps = 5 }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      marginBottom: '20px', gap: '2px', padding: '4px 0'
    }}>
      {[...Array(totalSteps)].map((_, i) => {
        const n = i + 1;
        const isActive = n === step;
        const isDone = n < step;
        return (
          <React.Fragment key={n}>
            <div style={{
              width: '34px', height: '34px', borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '15px', fontWeight: '900',
              fontFamily: "'Bangers', cursive",
              letterSpacing: '0.5px',
              color: isActive ? '#F5EDD6' : isDone ? '#F5EDD6' : '#8B6914',
              background: isActive
                ? 'linear-gradient(160deg, #C87400, #D4A017)'
                : isDone
                  ? '#3D1F0A'
                  : 'rgba(61,31,10,0.1)',
              border: isActive
                ? '3px solid #3D1F0A'
                : isDone
                  ? '2px solid #3D1F0A'
                  : '2px solid rgba(61,31,10,0.25)',
              boxShadow: isActive ? '0 4px 0 #7A4A00, 0 0 14px rgba(212,160,23,0.4)' : 'none',
              transform: isActive ? 'translateY(-3px) scale(1.12)' : 'none',
              transition: 'all 0.3s ease',
              zIndex: isActive ? 2 : 1,
              position: 'relative',
            }}>
              {isDone ? '✓' : n}
            </div>
            {n < totalSteps && (
              <div style={{
                width: '14px', height: '3px',
                background: isDone
                  ? 'linear-gradient(90deg, #C87400, #D4A017)'
                  : 'rgba(61,31,10,0.15)',
                borderRadius: '2px',
                transition: 'background 0.3s ease',
              }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
